import { render, staticRenderFns } from "./edit-resource.vue?vue&type=template&id=50d99a8e&scoped=true&"
import script from "./edit-resource.vue?vue&type=script&lang=ts&"
export * from "./edit-resource.vue?vue&type=script&lang=ts&"
import style0 from "./edit-resource.vue?vue&type=style&index=0&id=50d99a8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d99a8e",
  null
  
)

export default component.exports